export const lightTheme = {
  "themePrimary": "#fd6262",
  "themeLighterAlt": "#fff9f9",
  "themeLighter": "#ffe6e6",
  "themeLight": "#fed0d0",
  "themeTertiary": "#fda1a1",
  "themeSecondary": "#fd7575",
  "themeDarkAlt": "#e35959",
  "themeDark": "#c04b4b",
  "themeDarker": "#8d3737",
  "neutralLighterAlt": "#faf9f8",
  "neutralLighter": "#ffffff",
  "neutralLight": "#edebe9",
  "neutralQuaternaryAlt": "#e1dfdd",
  "neutralQuaternary": "#d0d0d0",
  "neutralTertiaryAlt": "#c8c6c4",
  "neutralTertiary": "#a19f9d",
  "neutralSecondary": "#605e5c",
  "neutralPrimaryAlt": "#3b3a39",
  "neutralPrimary": "#323130",
  "neutralDark": "#201f1e",
  "black": "#000000",
  "white": "#f5f5f5"
} as const;
